
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
* This file exports all enum related types from the schema.
*
* 🟢 You can import this file directly.
*/

export const AiPromptCategory = {
  CHAT: 'CHAT',
  EMBEDDING: 'EMBEDDING'
} as const

export type AiPromptCategory = (typeof AiPromptCategory)[keyof typeof AiPromptCategory]


export const AiPromptProvider = {
  OPENAI: 'OPENAI',
  GOOGLE: 'GOOGLE',
  ANTHROPIC: 'ANTHROPIC',
  ZEROENTROPY: 'ZEROENTROPY',
  COHERE: 'COHERE'
} as const

export type AiPromptProvider = (typeof AiPromptProvider)[keyof typeof AiPromptProvider]


export const AiPromptStatus = {
  DRAFT: 'DRAFT',
  PUBLISHED: 'PUBLISHED',
  ARCHIVED: 'ARCHIVED'
} as const

export type AiPromptStatus = (typeof AiPromptStatus)[keyof typeof AiPromptStatus]


export const AiEvalRunStatus = {
  RUNNING: 'RUNNING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  CANCELLED: 'CANCELLED'
} as const

export type AiEvalRunStatus = (typeof AiEvalRunStatus)[keyof typeof AiEvalRunStatus]


export const AiEvalResultStatus = {
  PENDING: 'PENDING',
  PASSED: 'PASSED',
  FAILED: 'FAILED',
  ERROR: 'ERROR'
} as const

export type AiEvalResultStatus = (typeof AiEvalResultStatus)[keyof typeof AiEvalResultStatus]


export const AiEvalCaseStatus = {
  DRAFT: 'DRAFT',
  APPROVED: 'APPROVED',
  RETIRED: 'RETIRED'
} as const

export type AiEvalCaseStatus = (typeof AiEvalCaseStatus)[keyof typeof AiEvalCaseStatus]


export const AiLodgementRunStatus = {
  UPLOADING: 'UPLOADING',
  QUEUED: 'QUEUED',
  ANALYSING: 'ANALYSING',
  AWAITING_PRODUCT: 'AWAITING_PRODUCT',
  PREFILLING: 'PREFILLING',
  READY: 'READY',
  LODGED: 'LODGED',
  FAILED: 'FAILED',
  CANCELLED: 'CANCELLED',
  EXPIRED: 'EXPIRED'
} as const

export type AiLodgementRunStatus = (typeof AiLodgementRunStatus)[keyof typeof AiLodgementRunStatus]


export const AiLodgementRunMode = {
  INTERACTIVE: 'INTERACTIVE',
  UNATTENDED: 'UNATTENDED'
} as const

export type AiLodgementRunMode = (typeof AiLodgementRunMode)[keyof typeof AiLodgementRunMode]


export const AiLodgementAnalysisStage = {
  VERIFYING: 'VERIFYING',
  READING: 'READING',
  CHOOSING_PRODUCT: 'CHOOSING_PRODUCT'
} as const

export type AiLodgementAnalysisStage = (typeof AiLodgementAnalysisStage)[keyof typeof AiLodgementAnalysisStage]


export const AiLodgementRunFailureCode = {
  NO_FILES: 'NO_FILES',
  NO_READABLE_FILES: 'NO_READABLE_FILES',
  INTERNAL_ERROR: 'INTERNAL_ERROR'
} as const

export type AiLodgementRunFailureCode = (typeof AiLodgementRunFailureCode)[keyof typeof AiLodgementRunFailureCode]


export const AiLodgementRunFileKind = {
  UPLOAD: 'UPLOAD',
  EMAIL_ATTACHMENT: 'EMAIL_ATTACHMENT'
} as const

export type AiLodgementRunFileKind = (typeof AiLodgementRunFileKind)[keyof typeof AiLodgementRunFileKind]


export const AiLodgementRunFileStatus = {
  AWAITING_UPLOAD: 'AWAITING_UPLOAD',
  QUEUED: 'QUEUED',
  EXTRACTED: 'EXTRACTED',
  SKIPPED: 'SKIPPED',
  FAILED: 'FAILED'
} as const

export type AiLodgementRunFileStatus = (typeof AiLodgementRunFileStatus)[keyof typeof AiLodgementRunFileStatus]


export const AiLodgementRunFileSkipReason = {
  NOT_UPLOADED: 'NOT_UPLOADED',
  TOO_LARGE: 'TOO_LARGE',
  TYPE_MISMATCH: 'TYPE_MISMATCH',
  UNSUPPORTED_TYPE: 'UNSUPPORTED_TYPE',
  DUPLICATE: 'DUPLICATE',
  TOO_MANY_FILES: 'TOO_MANY_FILES',
  EMPTY: 'EMPTY',
  UNREADABLE: 'UNREADABLE',
  TOO_DEEP: 'TOO_DEEP'
} as const

export type AiLodgementRunFileSkipReason = (typeof AiLodgementRunFileSkipReason)[keyof typeof AiLodgementRunFileSkipReason]


export const AiPrefillSourceType = {
  PASTE: 'PASTE',
  FILE: 'FILE'
} as const

export type AiPrefillSourceType = (typeof AiPrefillSourceType)[keyof typeof AiPrefillSourceType]


export const AutoGrabLookupMethod = {
  VIN: 'VIN',
  REGISTRATION: 'REGISTRATION'
} as const

export type AutoGrabLookupMethod = (typeof AutoGrabLookupMethod)[keyof typeof AutoGrabLookupMethod]


export const AutoGrabLookupTransportOutcome = {
  IN_FLIGHT: 'IN_FLIGHT',
  SUCCESS: 'SUCCESS',
  PROVIDER_ERROR: 'PROVIDER_ERROR',
  TRANSPORT_FAILURE: 'TRANSPORT_FAILURE',
  UNKNOWN: 'UNKNOWN'
} as const

export type AutoGrabLookupTransportOutcome = (typeof AutoGrabLookupTransportOutcome)[keyof typeof AutoGrabLookupTransportOutcome]


export const AutoGrabLookupMatchOutcome = {
  MATCHED: 'MATCHED',
  NO_MATCH: 'NO_MATCH',
  AMBIGUOUS: 'AMBIGUOUS',
  WARNING: 'WARNING',
  REGISTRY_ONLY: 'REGISTRY_ONLY',
  INVALID_RESPONSE: 'INVALID_RESPONSE'
} as const

export type AutoGrabLookupMatchOutcome = (typeof AutoGrabLookupMatchOutcome)[keyof typeof AutoGrabLookupMatchOutcome]


export const AutoGrabLookupSelectionState = {
  PENDING: 'PENDING',
  ACCEPTED: 'ACCEPTED',
  CANCELLED: 'CANCELLED'
} as const

export type AutoGrabLookupSelectionState = (typeof AutoGrabLookupSelectionState)[keyof typeof AutoGrabLookupSelectionState]


export const FleetVehicleVerificationVinSource = {
  RETURNED: 'RETURNED',
  SUPPLIED: 'SUPPLIED'
} as const

export type FleetVehicleVerificationVinSource = (typeof FleetVehicleVerificationVinSource)[keyof typeof FleetVehicleVerificationVinSource]


export const ClaimVehicleIdentityStatus = {
  VERIFIED: 'VERIFIED',
  UNVERIFIED: 'UNVERIFIED'
} as const

export type ClaimVehicleIdentityStatus = (typeof ClaimVehicleIdentityStatus)[keyof typeof ClaimVehicleIdentityStatus]


export const ClaimVehicleIdentityOrigin = {
  LIVE_LOOKUP: 'LIVE_LOOKUP',
  FLEET_VERIFICATION: 'FLEET_VERIFICATION',
  LODGED_DETAILS: 'LODGED_DETAILS'
} as const

export type ClaimVehicleIdentityOrigin = (typeof ClaimVehicleIdentityOrigin)[keyof typeof ClaimVehicleIdentityOrigin]


export const ClaimStatusType = {
  OPEN: 'OPEN',
  CLOSED: 'CLOSED'
} as const

export type ClaimStatusType = (typeof ClaimStatusType)[keyof typeof ClaimStatusType]


export const ClaimFlagSource = {
  ORGANISATION: 'ORGANISATION',
  CLAIM: 'CLAIM'
} as const

export type ClaimFlagSource = (typeof ClaimFlagSource)[keyof typeof ClaimFlagSource]


export const ClaimHandlingPartyOrigin = {
  PRODUCT: 'PRODUCT',
  MANUAL: 'MANUAL'
} as const

export type ClaimHandlingPartyOrigin = (typeof ClaimHandlingPartyOrigin)[keyof typeof ClaimHandlingPartyOrigin]


export const ClaimCompletionRequestStatus = {
  SENT: 'SENT',
  COMPLETED: 'COMPLETED',
  WITHDRAWN: 'WITHDRAWN'
} as const

export type ClaimCompletionRequestStatus = (typeof ClaimCompletionRequestStatus)[keyof typeof ClaimCompletionRequestStatus]


export const ClaimProductBinding = {
  AT_CREATION: 'AT_CREATION',
  PENDING: 'PENDING',
  BOUND: 'BOUND'
} as const

export type ClaimProductBinding = (typeof ClaimProductBinding)[keyof typeof ClaimProductBinding]


export const ClaimClosureOutcome = {
  CLAIM_SETTLED: 'CLAIM_SETTLED',
  CLAIM_DECLINED: 'CLAIM_DECLINED',
  WITHDRAWN: 'WITHDRAWN',
  NOT_A_CLAIM: 'NOT_A_CLAIM',
  DUPLICATE: 'DUPLICATE'
} as const

export type ClaimClosureOutcome = (typeof ClaimClosureOutcome)[keyof typeof ClaimClosureOutcome]


export const ClaimReviewState = {
  NONE: 'NONE',
  TO_REVIEW: 'TO_REVIEW',
  REVIEWED: 'REVIEWED'
} as const

export type ClaimReviewState = (typeof ClaimReviewState)[keyof typeof ClaimReviewState]


export const ClaimSource = {
  LODGEMENT_FORM: 'LODGEMENT_FORM',
  EMAIL: 'EMAIL',
  DOCUMENTS: 'DOCUMENTS',
  SERVICE_API: 'SERVICE_API',
  MANUAL: 'MANUAL',
  DEMO: 'DEMO'
} as const

export type ClaimSource = (typeof ClaimSource)[keyof typeof ClaimSource]


export const VehicleReturnSource = {
  MANUAL: 'MANUAL',
  CLEAR21: 'CLEAR21'
} as const

export type VehicleReturnSource = (typeof VehicleReturnSource)[keyof typeof VehicleReturnSource]


export const ClaimFlagType = {
  PRIMARY: 'PRIMARY',
  SECONDARY: 'SECONDARY',
  LABEL: 'LABEL'
} as const

export type ClaimFlagType = (typeof ClaimFlagType)[keyof typeof ClaimFlagType]


export const ClaimExcessOutcome = {
  OVER_EXCESS: 'OVER_EXCESS',
  UNDER_EXCESS: 'UNDER_EXCESS'
} as const

export type ClaimExcessOutcome = (typeof ClaimExcessOutcome)[keyof typeof ClaimExcessOutcome]


export const ClaimReserveChangeKind = {
  NEW_RESERVE: 'NEW_RESERVE',
  INCREASE: 'INCREASE'
} as const

export type ClaimReserveChangeKind = (typeof ClaimReserveChangeKind)[keyof typeof ClaimReserveChangeKind]


export const ClaimReserveChangeStatus = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  DECLINED: 'DECLINED'
} as const

export type ClaimReserveChangeStatus = (typeof ClaimReserveChangeStatus)[keyof typeof ClaimReserveChangeStatus]


export const ClaimReserveChangeRoute = {
  APPROVAL: 'APPROVAL',
  REFERRAL: 'REFERRAL'
} as const

export type ClaimReserveChangeRoute = (typeof ClaimReserveChangeRoute)[keyof typeof ClaimReserveChangeRoute]


export const ClaimEscalationRule = {
  REPAIRER_NOT_ASSIGNED: 'REPAIRER_NOT_ASSIGNED',
  QUOTE_NOT_RECEIVED: 'QUOTE_NOT_RECEIVED',
  QUOTE_NOT_ASSESSED: 'QUOTE_NOT_ASSESSED'
} as const

export type ClaimEscalationRule = (typeof ClaimEscalationRule)[keyof typeof ClaimEscalationRule]


export const ClaimEscalationOutcome = {
  SENT: 'SENT',
  SUPPRESSED_NO_RECIPIENT: 'SUPPRESSED_NO_RECIPIENT',
  SUPPRESSED_NO_TEMPLATE: 'SUPPRESSED_NO_TEMPLATE',
  SEND_FAILED: 'SEND_FAILED',
  CANCELLED_RULE_MET: 'CANCELLED_RULE_MET'
} as const

export type ClaimEscalationOutcome = (typeof ClaimEscalationOutcome)[keyof typeof ClaimEscalationOutcome]


export const ClaimStateTaskSeedStatus = {
  PENDING: 'PENDING',
  SEEDED: 'SEEDED',
  SKIPPED: 'SKIPPED',
  FAILED: 'FAILED'
} as const

export type ClaimStateTaskSeedStatus = (typeof ClaimStateTaskSeedStatus)[keyof typeof ClaimStateTaskSeedStatus]


export const ClaraActionExecutionStatus = {
  PENDING: 'PENDING',
  EXECUTED: 'EXECUTED',
  SKIPPED: 'SKIPPED',
  REFUSED: 'REFUSED',
  FAILED: 'FAILED'
} as const

export type ClaraActionExecutionStatus = (typeof ClaraActionExecutionStatus)[keyof typeof ClaraActionExecutionStatus]


export const ClaraAgentRunStatus = {
  RUNNING: 'RUNNING',
  SUCCEEDED: 'SUCCEEDED',
  FAILED: 'FAILED',
  SKIPPED: 'SKIPPED'
} as const

export type ClaraAgentRunStatus = (typeof ClaraAgentRunStatus)[keyof typeof ClaraAgentRunStatus]


export const CommLogStatus = {
  DRAFT: 'DRAFT',
  SENDING: 'SENDING',
  ACTIVE: 'ACTIVE'
} as const

export type CommLogStatus = (typeof CommLogStatus)[keyof typeof CommLogStatus]


export const CommLogRoutingStatus = {
  NONE: 'NONE',
  PENDING: 'PENDING',
  ROUTED: 'ROUTED'
} as const

export type CommLogRoutingStatus = (typeof CommLogRoutingStatus)[keyof typeof CommLogRoutingStatus]


export const CommLogMatchMethod = {
  HEADER: 'HEADER',
  SUBJECT_REF: 'SUBJECT_REF',
  CONTACT: 'CONTACT',
  AI: 'AI',
  MANUAL: 'MANUAL'
} as const

export type CommLogMatchMethod = (typeof CommLogMatchMethod)[keyof typeof CommLogMatchMethod]


export const CommLogDeliveryState = {
  SENT: 'SENT',
  FAILED: 'FAILED'
} as const

export type CommLogDeliveryState = (typeof CommLogDeliveryState)[keyof typeof CommLogDeliveryState]


export const CommRecipientRole = {
  TO: 'TO',
  CC: 'CC',
  BCC: 'BCC'
} as const

export type CommRecipientRole = (typeof CommRecipientRole)[keyof typeof CommRecipientRole]


export const CommTemplateChannel = {
  EMAIL: 'EMAIL',
  SMS: 'SMS'
} as const

export type CommTemplateChannel = (typeof CommTemplateChannel)[keyof typeof CommTemplateChannel]


export const CommTemplateRelatedTo = {
  claim: 'claim',
  complaint: 'complaint',
  control: 'control',
  incident: 'incident',
  mspr: 'mspr',
  org: 'org',
  user: 'user',
  risk: 'risk',
  task: 'task',
  lodgement: 'lodgement'
} as const

export type CommTemplateRelatedTo = (typeof CommTemplateRelatedTo)[keyof typeof CommTemplateRelatedTo]


export const CommTemplatePurpose = {
  CLAIMANT_CONFIRMATION: 'CLAIMANT_CONFIRMATION',
  INTERNAL_NOTIFICATION: 'INTERNAL_NOTIFICATION',
  DRAFT_RESUME: 'DRAFT_RESUME',
  CLAIM_COMPLETION: 'CLAIM_COMPLETION'
} as const

export type CommTemplatePurpose = (typeof CommTemplatePurpose)[keyof typeof CommTemplatePurpose]


export const CommTemplateStatus = {
  DRAFT: 'DRAFT',
  PUBLISHED: 'PUBLISHED',
  ARCHIVED: 'ARCHIVED'
} as const

export type CommTemplateStatus = (typeof CommTemplateStatus)[keyof typeof CommTemplateStatus]


export const ComplaintFlagSource = {
  ORGANISATION: 'ORGANISATION',
  COMPLAINT: 'COMPLAINT'
} as const

export type ComplaintFlagSource = (typeof ComplaintFlagSource)[keyof typeof ComplaintFlagSource]


export const ComplaintFlagType = {
  PRIMARY: 'PRIMARY',
  SECONDARY: 'SECONDARY',
  LABEL: 'LABEL'
} as const

export type ComplaintFlagType = (typeof ComplaintFlagType)[keyof typeof ComplaintFlagType]


export const ComplaintFlagTag = {
  VULNERABILITY: 'VULNERABILITY'
} as const

export type ComplaintFlagTag = (typeof ComplaintFlagTag)[keyof typeof ComplaintFlagTag]


export const ComplaintFlagAttachedBy = {
  USER: 'USER',
  AI: 'AI'
} as const

export type ComplaintFlagAttachedBy = (typeof ComplaintFlagAttachedBy)[keyof typeof ComplaintFlagAttachedBy]


export const ComplaintAiAnalysisStatus = {
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED'
} as const

export type ComplaintAiAnalysisStatus = (typeof ComplaintAiAnalysisStatus)[keyof typeof ComplaintAiAnalysisStatus]


export const ComplaintAiAnalysisStage = {
  FINDING_OBLIGATIONS: 'FINDING_OBLIGATIONS',
  ASSESSING: 'ASSESSING',
  SAVING: 'SAVING'
} as const

export type ComplaintAiAnalysisStage = (typeof ComplaintAiAnalysisStage)[keyof typeof ComplaintAiAnalysisStage]


export const ComplaintFlagSuggestionStatus = {
  SUGGESTED: 'SUGGESTED',
  ACCEPTED: 'ACCEPTED',
  DISMISSED: 'DISMISSED'
} as const

export type ComplaintFlagSuggestionStatus = (typeof ComplaintFlagSuggestionStatus)[keyof typeof ComplaintFlagSuggestionStatus]


export const ComplaintBreachSource = {
  AI: 'AI',
  MANUAL: 'MANUAL'
} as const

export type ComplaintBreachSource = (typeof ComplaintBreachSource)[keyof typeof ComplaintBreachSource]


export const ComplianceAuditStatus = {
  NOT_STARTED: 'NOT_STARTED',
  PENDING: 'PENDING',
  WAITING: 'WAITING',
  PASSED: 'PASSED',
  FAILED: 'FAILED',
  ERROR: 'ERROR'
} as const

export type ComplianceAuditStatus = (typeof ComplianceAuditStatus)[keyof typeof ComplianceAuditStatus]


export const ComplianceAuditStepStatus = {
  NOT_STARTED: 'NOT_STARTED',
  PENDING: 'PENDING',
  WAITING: 'WAITING',
  QUERIED: 'QUERIED',
  PASSED: 'PASSED',
  FAILED: 'FAILED',
  ERROR: 'ERROR',
  NOT_APPLICABLE: 'NOT_APPLICABLE'
} as const

export type ComplianceAuditStepStatus = (typeof ComplianceAuditStepStatus)[keyof typeof ComplianceAuditStepStatus]


export const ComplianceAuditSubStepStatus = {
  PENDING: 'PENDING',
  PASSED: 'PASSED',
  FAILED: 'FAILED',
  QUERIED: 'QUERIED',
  NOT_APPLICABLE: 'NOT_APPLICABLE'
} as const

export type ComplianceAuditSubStepStatus = (typeof ComplianceAuditSubStepStatus)[keyof typeof ComplianceAuditSubStepStatus]


export const ComplianceAuditSubStepType = {
  CHECK: 'CHECK',
  CLASSIFICATION: 'CLASSIFICATION'
} as const

export type ComplianceAuditSubStepType = (typeof ComplianceAuditSubStepType)[keyof typeof ComplianceAuditSubStepType]


export const ComplianceAuditLlmAttributionMode = {
  TAGGED: 'TAGGED',
  LEGACY: 'LEGACY'
} as const

export type ComplianceAuditLlmAttributionMode = (typeof ComplianceAuditLlmAttributionMode)[keyof typeof ComplianceAuditLlmAttributionMode]


export const ComplianceAuditChatRole = {
  SYSTEM: 'SYSTEM',
  USER: 'USER'
} as const

export type ComplianceAuditChatRole = (typeof ComplianceAuditChatRole)[keyof typeof ComplianceAuditChatRole]


export const ComplianceAuditFindingType = {
  COMPLAINT: 'COMPLAINT',
  INCIDENT: 'INCIDENT'
} as const

export type ComplianceAuditFindingType = (typeof ComplianceAuditFindingType)[keyof typeof ComplianceAuditFindingType]


export const ComplianceAuditFindingStatus = {
  LOGGED: 'LOGGED',
  POSSIBLE: 'POSSIBLE',
  DISMISSED: 'DISMISSED',
  DRAFT: 'DRAFT',
  DUPLICATE: 'DUPLICATE'
} as const

export type ComplianceAuditFindingStatus = (typeof ComplianceAuditFindingStatus)[keyof typeof ComplianceAuditFindingStatus]


export const ComplianceAuditActivityKind = {
  SYSTEM_STARTED: 'SYSTEM_STARTED',
  SYSTEM_DECIDED: 'SYSTEM_DECIDED',
  SYSTEM_PAUSED: 'SYSTEM_PAUSED',
  SYSTEM_RESUMED: 'SYSTEM_RESUMED',
  SYSTEM_RERUN: 'SYSTEM_RERUN',
  SYSTEM_QUESTION: 'SYSTEM_QUESTION',
  SYSTEM_DEFAULTED: 'SYSTEM_DEFAULTED',
  USER_OVERRIDE: 'USER_OVERRIDE',
  USER_NOTE: 'USER_NOTE',
  USER_CHASE: 'USER_CHASE',
  USER_RESOLVED: 'USER_RESOLVED',
  USER_ACKNOWLEDGED: 'USER_ACKNOWLEDGED',
  FINDING_RAISED: 'FINDING_RAISED',
  FINDING_LOGGED: 'FINDING_LOGGED',
  FINDING_DISMISSED: 'FINDING_DISMISSED',
  FINDING_RESTORED: 'FINDING_RESTORED',
  FINDING_MERGED: 'FINDING_MERGED',
  SUB_STEP_STARTED: 'SUB_STEP_STARTED',
  SUB_STEP_FINISHED: 'SUB_STEP_FINISHED',
  CONFLICT_DETECTED: 'CONFLICT_DETECTED',
  FLAG_RAISED: 'FLAG_RAISED'
} as const

export type ComplianceAuditActivityKind = (typeof ComplianceAuditActivityKind)[keyof typeof ComplianceAuditActivityKind]


export const ComplianceAuditFileContentAssessment = {
  DRAFT: 'DRAFT',
  FINAL: 'FINAL'
} as const

export type ComplianceAuditFileContentAssessment = (typeof ComplianceAuditFileContentAssessment)[keyof typeof ComplianceAuditFileContentAssessment]


export const ComplianceAuditTemplateVersionStatus = {
  DRAFT: 'DRAFT',
  PUBLISHED: 'PUBLISHED'
} as const

export type ComplianceAuditTemplateVersionStatus = (typeof ComplianceAuditTemplateVersionStatus)[keyof typeof ComplianceAuditTemplateVersionStatus]


export const ComplianceAuditTemplateType = {
  HARDCODED: 'HARDCODED',
  CUSTOM: 'CUSTOM'
} as const

export type ComplianceAuditTemplateType = (typeof ComplianceAuditTemplateType)[keyof typeof ComplianceAuditTemplateType]


export const ComplianceAuditTemplateSubStepType = {
  CHECK: 'CHECK',
  CLASSIFICATION: 'CLASSIFICATION'
} as const

export type ComplianceAuditTemplateSubStepType = (typeof ComplianceAuditTemplateSubStepType)[keyof typeof ComplianceAuditTemplateSubStepType]


export const EvidenceRetrievalMode = {
  SEARCH: 'SEARCH',
  FULL_DOCUMENT_SCAN: 'FULL_DOCUMENT_SCAN'
} as const

export type EvidenceRetrievalMode = (typeof EvidenceRetrievalMode)[keyof typeof EvidenceRetrievalMode]


export const ComplianceScanType = {
  QUICK: 'QUICK',
  FULL: 'FULL',
  SINGLE_PAGE: 'SINGLE_PAGE'
} as const

export type ComplianceScanType = (typeof ComplianceScanType)[keyof typeof ComplianceScanType]


export const ComplianceScanStatus = {
  PENDING: 'PENDING',
  SCRAPING: 'SCRAPING',
  SCRAPE_FAILED: 'SCRAPE_FAILED',
  ANALYZING: 'ANALYZING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  CANCELLED: 'CANCELLED'
} as const

export type ComplianceScanStatus = (typeof ComplianceScanStatus)[keyof typeof ComplianceScanStatus]


export const ContactType = {
  BROKER: 'BROKER',
  SUPPLIER: 'SUPPLIER',
  INSURER: 'INSURER',
  POLICY_HOLDER: 'POLICY_HOLDER',
  THIRD_PARTY: 'THIRD_PARTY',
  DRIVER: 'DRIVER'
} as const

export type ContactType = (typeof ContactType)[keyof typeof ContactType]


export const PreferredContactMethod = {
  EMAIL: 'EMAIL',
  PHONE: 'PHONE',
  POST: 'POST'
} as const

export type PreferredContactMethod = (typeof PreferredContactMethod)[keyof typeof PreferredContactMethod]


export const PayIdType = {
  EMAIL: 'EMAIL',
  PHONE: 'PHONE',
  ABN: 'ABN',
  ORGANIZATION_ID: 'ORGANIZATION_ID'
} as const

export type PayIdType = (typeof PayIdType)[keyof typeof PayIdType]


export const DecisionEngineExtractionStatus = {
  PENDING: 'PENDING',
  EXTRACTING_TEXT: 'EXTRACTING_TEXT',
  GENERATING: 'GENERATING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  CANCELLED: 'CANCELLED'
} as const

export type DecisionEngineExtractionStatus = (typeof DecisionEngineExtractionStatus)[keyof typeof DecisionEngineExtractionStatus]


export const DemoTemplateRunStatus = {
  PENDING: 'PENDING',
  RUNNING: 'RUNNING',
  SUCCESS: 'SUCCESS',
  PARTIAL: 'PARTIAL',
  FAILED: 'FAILED'
} as const

export type DemoTemplateRunStatus = (typeof DemoTemplateRunStatus)[keyof typeof DemoTemplateRunStatus]


export const DocumentAnalysisStatus = {
  PREVIEW: 'PREVIEW',
  PENDING: 'PENDING',
  EXTRACTING_TEXT: 'EXTRACTING_TEXT',
  SEGMENTING: 'SEGMENTING',
  ANALYZING: 'ANALYZING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  CANCELLED: 'CANCELLED'
} as const

export type DocumentAnalysisStatus = (typeof DocumentAnalysisStatus)[keyof typeof DocumentAnalysisStatus]


export const BreachStatus = {
  PASS: 'PASS',
  FAIL: 'FAIL',
  UNCLEAR: 'UNCLEAR'
} as const

export type BreachStatus = (typeof BreachStatus)[keyof typeof BreachStatus]


export const BreachSeverity = {
  LOW: 'LOW',
  MEDIUM: 'MEDIUM',
  HIGH: 'HIGH',
  CRITICAL: 'CRITICAL'
} as const

export type BreachSeverity = (typeof BreachSeverity)[keyof typeof BreachSeverity]


export const EngagementAlertType = {
  SCORE_DROP: 'SCORE_DROP',
  TIER_CHANGE: 'TIER_CHANGE',
  DIMENSION_CRITICAL: 'DIMENSION_CRITICAL',
  NO_LOGIN: 'NO_LOGIN',
  CHURN_RISK: 'CHURN_RISK'
} as const

export type EngagementAlertType = (typeof EngagementAlertType)[keyof typeof EngagementAlertType]


export const EngagementAlertSeverity = {
  INFO: 'INFO',
  WARNING: 'WARNING',
  CRITICAL: 'CRITICAL'
} as const

export type EngagementAlertSeverity = (typeof EngagementAlertSeverity)[keyof typeof EngagementAlertSeverity]


export const EngagementAlertStatus = {
  ACTIVE: 'ACTIVE',
  ACKNOWLEDGED: 'ACKNOWLEDGED',
  RESOLVED: 'RESOLVED',
  DISMISSED: 'DISMISSED'
} as const

export type EngagementAlertStatus = (typeof EngagementAlertStatus)[keyof typeof EngagementAlertStatus]


export const FieldConfigurationEntity = {
  COMPLAINT: 'COMPLAINT',
  INCIDENT: 'INCIDENT',
  PRODUCT_TYPE: 'PRODUCT_TYPE',
  PRODUCT_VERSION: 'PRODUCT_VERSION',
  TRAINING: 'TRAINING'
} as const

export type FieldConfigurationEntity = (typeof FieldConfigurationEntity)[keyof typeof FieldConfigurationEntity]


export const StorageProvider = {
  S3: 'S3',
  DO_SPACES: 'DO_SPACES'
} as const

export type StorageProvider = (typeof StorageProvider)[keyof typeof StorageProvider]


export const ClaimTransactionType = {
  RESERVE: 'RESERVE',
  INDEMNITY_AND_EXPENSE: 'INDEMNITY_AND_EXPENSE',
  EXCESS: 'EXCESS',
  RECOVERY_AND_SALVAGE: 'RECOVERY_AND_SALVAGE'
} as const

export type ClaimTransactionType = (typeof ClaimTransactionType)[keyof typeof ClaimTransactionType]


export const TransactionNature = {
  RESERVE: 'RESERVE',
  RESERVE_INCREASE: 'RESERVE_INCREASE',
  RESERVE_DECREASE: 'RESERVE_DECREASE',
  EXCESS: 'EXCESS',
  INDEMNITY: 'INDEMNITY',
  EXPENSE: 'EXPENSE',
  SUBROGATED_RECOVERY: 'SUBROGATED_RECOVERY',
  NON_SUBROGATED_RECOVERY: 'NON_SUBROGATED_RECOVERY',
  SALVAGE: 'SALVAGE',
  REFUND: 'REFUND'
} as const

export type TransactionNature = (typeof TransactionNature)[keyof typeof TransactionNature]


export const AutoReserveType = {
  GROSS: 'GROSS',
  NET: 'NET'
} as const

export type AutoReserveType = (typeof AutoReserveType)[keyof typeof AutoReserveType]


export const ExcessPaymentStatus = {
  PENDING: 'PENDING',
  FULLY_SETTLED: 'FULLY_SETTLED'
} as const

export type ExcessPaymentStatus = (typeof ExcessPaymentStatus)[keyof typeof ExcessPaymentStatus]


export const ExcessPaymentMethod = {
  DIRECT_TO_INSURER: 'DIRECT_TO_INSURER',
  SUPPLIER_OFFSET: 'SUPPLIER_OFFSET',
  DEDUCTED_FROM_INSURED_SETTLEMENT: 'DEDUCTED_FROM_INSURED_SETTLEMENT'
} as const

export type ExcessPaymentMethod = (typeof ExcessPaymentMethod)[keyof typeof ExcessPaymentMethod]


export const ExcessContributionMethod = {
  UNKNOWN: 'UNKNOWN',
  DIRECT_TO_INSURER: 'DIRECT_TO_INSURER',
  SUPPLIER_OFFSET: 'SUPPLIER_OFFSET',
  DEDUCTED_FROM_INSURED_SETTLEMENT: 'DEDUCTED_FROM_INSURED_SETTLEMENT',
  MIXED: 'MIXED'
} as const

export type ExcessContributionMethod = (typeof ExcessContributionMethod)[keyof typeof ExcessContributionMethod]


export const ExcessStatus = {
  UNRESOLVED: 'UNRESOLVED',
  PENDING: 'PENDING',
  PARTIALLY_SETTLED: 'PARTIALLY_SETTLED',
  FULLY_SETTLED: 'FULLY_SETTLED',
  WAIVED: 'WAIVED',
  CANCELLED: 'CANCELLED'
} as const

export type ExcessStatus = (typeof ExcessStatus)[keyof typeof ExcessStatus]


export const CompensationPaymentUseType = {
  BUSINESS: 'BUSINESS',
  PERSONAL: 'PERSONAL',
  MIXED: 'MIXED'
} as const

export type CompensationPaymentUseType = (typeof CompensationPaymentUseType)[keyof typeof CompensationPaymentUseType]


export const PayeeType = {
  POLICY_HOLDER: 'POLICY_HOLDER',
  OTHER_CONTACT: 'OTHER_CONTACT',
  SUPPLIER: 'SUPPLIER'
} as const

export type PayeeType = (typeof PayeeType)[keyof typeof PayeeType]


export const CompensationPaymentMethod = {
  PAY_ID: 'PAY_ID',
  BANK_ACCOUNT: 'BANK_ACCOUNT'
} as const

export type CompensationPaymentMethod = (typeof CompensationPaymentMethod)[keyof typeof CompensationPaymentMethod]


export const CompensationStatus = {
  DRAFT: 'DRAFT',
  INITIALIZED: 'INITIALIZED'
} as const

export type CompensationStatus = (typeof CompensationStatus)[keyof typeof CompensationStatus]


export const FleetClientType = {
  CONSOLIDATOR: 'CONSOLIDATOR',
  CLIENT: 'CLIENT'
} as const

export type FleetClientType = (typeof FleetClientType)[keyof typeof FleetClientType]


export const ClaimAuthorisationStatus = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  DECLINED: 'DECLINED',
  SUPERSEDED: 'SUPERSEDED'
} as const

export type ClaimAuthorisationStatus = (typeof ClaimAuthorisationStatus)[keyof typeof ClaimAuthorisationStatus]


export const ClaimAuthorisationAmountBasis = {
  ESTIMATE: 'ESTIMATE',
  ASSESSED: 'ASSESSED'
} as const

export type ClaimAuthorisationAmountBasis = (typeof ClaimAuthorisationAmountBasis)[keyof typeof ClaimAuthorisationAmountBasis]


export const ClaimAuthorisationDecisionSource = {
  INGESTED: 'INGESTED',
  SEEDED: 'SEEDED'
} as const

export type ClaimAuthorisationDecisionSource = (typeof ClaimAuthorisationDecisionSource)[keyof typeof ClaimAuthorisationDecisionSource]


export const FormSchemaStatus = {
  DRAFT: 'DRAFT',
  PUBLISHED: 'PUBLISHED',
  ARCHIVED: 'ARCHIVED'
} as const

export type FormSchemaStatus = (typeof FormSchemaStatus)[keyof typeof FormSchemaStatus]


export const InboundEmailArchiveStatus = {
  RECEIVED: 'RECEIVED',
  PROCESSED: 'PROCESSED',
  REJECTED: 'REJECTED',
  PARSE_FAILED: 'PARSE_FAILED',
  PROCESSING_FAILED: 'PROCESSING_FAILED'
} as const

export type InboundEmailArchiveStatus = (typeof InboundEmailArchiveStatus)[keyof typeof InboundEmailArchiveStatus]


export const IncidentFlagSource = {
  ORGANISATION: 'ORGANISATION',
  INCIDENT: 'INCIDENT'
} as const

export type IncidentFlagSource = (typeof IncidentFlagSource)[keyof typeof IncidentFlagSource]


export const IncidentFlagType = {
  PRIMARY: 'PRIMARY',
  SECONDARY: 'SECONDARY',
  LABEL: 'LABEL'
} as const

export type IncidentFlagType = (typeof IncidentFlagType)[keyof typeof IncidentFlagType]


export const IncidentFlagTag = {
  VULNERABILITY: 'VULNERABILITY'
} as const

export type IncidentFlagTag = (typeof IncidentFlagTag)[keyof typeof IncidentFlagTag]


export const IncidentAiAnalysisStatus = {
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED'
} as const

export type IncidentAiAnalysisStatus = (typeof IncidentAiAnalysisStatus)[keyof typeof IncidentAiAnalysisStatus]


export const IncidentAiAnalysisStage = {
  FINDING_OBLIGATIONS: 'FINDING_OBLIGATIONS',
  ASSESSING: 'ASSESSING',
  SAVING: 'SAVING'
} as const

export type IncidentAiAnalysisStage = (typeof IncidentAiAnalysisStage)[keyof typeof IncidentAiAnalysisStage]


export const BreachReviewStatus = {
  CONFIRMED: 'CONFIRMED',
  DISMISSED: 'DISMISSED'
} as const

export type BreachReviewStatus = (typeof BreachReviewStatus)[keyof typeof BreachReviewStatus]


export const IncidentFlagSuggestionStatus = {
  SUGGESTED: 'SUGGESTED',
  ACCEPTED: 'ACCEPTED',
  DISMISSED: 'DISMISSED'
} as const

export type IncidentFlagSuggestionStatus = (typeof IncidentFlagSuggestionStatus)[keyof typeof IncidentFlagSuggestionStatus]


export const IntegrationTestRunTrigger = {
  MANUAL: 'MANUAL',
  SCHEDULED: 'SCHEDULED'
} as const

export type IntegrationTestRunTrigger = (typeof IntegrationTestRunTrigger)[keyof typeof IntegrationTestRunTrigger]


export const IntegrationTestRunStatus = {
  RUNNING: 'RUNNING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED'
} as const

export type IntegrationTestRunStatus = (typeof IntegrationTestRunStatus)[keyof typeof IntegrationTestRunStatus]


export const IntegrationTestResultStatus = {
  PASSED: 'PASSED',
  FAILED: 'FAILED',
  WARNING: 'WARNING',
  DISABLED: 'DISABLED',
  SKIPPED: 'SKIPPED'
} as const

export type IntegrationTestResultStatus = (typeof IntegrationTestResultStatus)[keyof typeof IntegrationTestResultStatus]


export const LlmRequestLogSanitizationStatus = {
  PENDING: 'PENDING',
  SUCCEEDED: 'SUCCEEDED',
  SUCCEEDED_DEGRADED: 'SUCCEEDED_DEGRADED',
  FAILED: 'FAILED'
} as const

export type LlmRequestLogSanitizationStatus = (typeof LlmRequestLogSanitizationStatus)[keyof typeof LlmRequestLogSanitizationStatus]


export const LodgementLinkStatus = {
  ACTIVE: 'ACTIVE',
  PAUSED: 'PAUSED',
  REVOKED: 'REVOKED'
} as const

export type LodgementLinkStatus = (typeof LodgementLinkStatus)[keyof typeof LodgementLinkStatus]


export const LodgementLinkChannel = {
  WEBSITE: 'WEBSITE',
  EMBED: 'EMBED',
  QR: 'QR',
  INTERNAL: 'INTERNAL'
} as const

export type LodgementLinkChannel = (typeof LodgementLinkChannel)[keyof typeof LodgementLinkChannel]


export const LodgementLinkKind = {
  PRODUCT: 'PRODUCT',
  NOTIFICATION: 'NOTIFICATION'
} as const

export type LodgementLinkKind = (typeof LodgementLinkKind)[keyof typeof LodgementLinkKind]


export const LodgementCaptchaPolicy = {
  ORG_DEFAULT: 'ORG_DEFAULT',
  REQUIRED: 'REQUIRED',
  OFF: 'OFF'
} as const

export type LodgementCaptchaPolicy = (typeof LodgementCaptchaPolicy)[keyof typeof LodgementCaptchaPolicy]


export const LodgementSubmissionStatus = {
  DRAFT: 'DRAFT',
  SUBMITTED: 'SUBMITTED',
  PROCESSING: 'PROCESSING',
  PROCESSED: 'PROCESSED',
  FAILED: 'FAILED',
  REJECTED: 'REJECTED',
  EXPIRED: 'EXPIRED'
} as const

export type LodgementSubmissionStatus = (typeof LodgementSubmissionStatus)[keyof typeof LodgementSubmissionStatus]


export const LodgementStaffDeclarationPolicy = {
  STAFF_CONFIRMS: 'STAFF_CONFIRMS',
  NOT_ASKED: 'NOT_ASKED'
} as const

export type LodgementStaffDeclarationPolicy = (typeof LodgementStaffDeclarationPolicy)[keyof typeof LodgementStaffDeclarationPolicy]


export const LodgementDeclarationGiven = {
  VERBALLY: 'VERBALLY',
  IN_WRITING: 'IN_WRITING'
} as const

export type LodgementDeclarationGiven = (typeof LodgementDeclarationGiven)[keyof typeof LodgementDeclarationGiven]


export const LodgementCaptchaOutcome = {
  PASSED: 'PASSED',
  BYPASSED_ORG: 'BYPASSED_ORG',
  BYPASSED_KILL_SWITCH: 'BYPASSED_KILL_SWITCH',
  NOT_REQUIRED: 'NOT_REQUIRED'
} as const

export type LodgementCaptchaOutcome = (typeof LodgementCaptchaOutcome)[keyof typeof LodgementCaptchaOutcome]


export const LodgementSubmissionFileStatus = {
  PENDING: 'PENDING',
  ATTACHED: 'ATTACHED',
  MISSING: 'MISSING',
  REJECTED: 'REJECTED'
} as const

export type LodgementSubmissionFileStatus = (typeof LodgementSubmissionFileStatus)[keyof typeof LodgementSubmissionFileStatus]


export const MarketPdsStatus = {
  DRAFT: 'DRAFT',
  PROCESSING: 'PROCESSING',
  PUBLISHED: 'PUBLISHED',
  ARCHIVED: 'ARCHIVED'
} as const

export type MarketPdsStatus = (typeof MarketPdsStatus)[keyof typeof MarketPdsStatus]


export const MarketPdsSectionType = {
  COVERAGE: 'COVERAGE',
  EXCLUSION: 'EXCLUSION',
  CONDITION: 'CONDITION',
  LIMIT: 'LIMIT',
  DEFINITION: 'DEFINITION',
  PROCEDURE: 'PROCEDURE',
  GENERAL: 'GENERAL'
} as const

export type MarketPdsSectionType = (typeof MarketPdsSectionType)[keyof typeof MarketPdsSectionType]


export const MessageType = {
  EMAIL: 'EMAIL',
  SMS: 'SMS',
  INTAKE: 'INTAKE'
} as const

export type MessageType = (typeof MessageType)[keyof typeof MessageType]


export const MessageClassificationStatus = {
  PENDING: 'PENDING',
  PROCESSED: 'PROCESSED',
  ERROR: 'ERROR',
  REVIEWED: 'REVIEWED',
  SKIPPED: 'SKIPPED'
} as const

export type MessageClassificationStatus = (typeof MessageClassificationStatus)[keyof typeof MessageClassificationStatus]


export const MessageClassificationSkipCategory = {
  AUTO_REPLY: 'AUTO_REPLY',
  NEWSLETTER: 'NEWSLETTER',
  DELIVERY_FAILURE: 'DELIVERY_FAILURE',
  OUT_OF_OFFICE: 'OUT_OF_OFFICE',
  SPAM_PATTERN: 'SPAM_PATTERN',
  DUPLICATE: 'DUPLICATE',
  MARKETING: 'MARKETING',
  SEMANTIC_DUPLICATE: 'SEMANTIC_DUPLICATE',
  AUTOMATED_REPORT: 'AUTOMATED_REPORT'
} as const

export type MessageClassificationSkipCategory = (typeof MessageClassificationSkipCategory)[keyof typeof MessageClassificationSkipCategory]


export const MessageClassificationFeedbackReasonCode = {
  WRONG_TOPIC: 'WRONG_TOPIC',
  TOPIC_RIGHT_NO_BREACH: 'TOPIC_RIGHT_NO_BREACH',
  TOPIC_RIGHT_NO_OBLIGATION_MATCH: 'TOPIC_RIGHT_NO_OBLIGATION_MATCH',
  SENTIMENT_MISREAD: 'SENTIMENT_MISREAD',
  SARCASM: 'SARCASM',
  MISSING_CONTEXT: 'MISSING_CONTEXT',
  OTHER: 'OTHER'
} as const

export type MessageClassificationFeedbackReasonCode = (typeof MessageClassificationFeedbackReasonCode)[keyof typeof MessageClassificationFeedbackReasonCode]


export const MessageClassificationClaimLinkSource = {
  DETECTED: 'DETECTED',
  INFERRED_FROM_SENDER: 'INFERRED_FROM_SENDER',
  INFERRED_FROM_POLICY: 'INFERRED_FROM_POLICY',
  MANUAL: 'MANUAL'
} as const

export type MessageClassificationClaimLinkSource = (typeof MessageClassificationClaimLinkSource)[keyof typeof MessageClassificationClaimLinkSource]


export const MessageVulnerabilityStatus = {
  DETECTED: 'DETECTED',
  CONFIRMED: 'CONFIRMED',
  DISMISSED: 'DISMISSED',
  PROMOTED: 'PROMOTED'
} as const

export type MessageVulnerabilityStatus = (typeof MessageVulnerabilityStatus)[keyof typeof MessageVulnerabilityStatus]


export const MessageVulnerabilityOrigin = {
  DETECTED: 'DETECTED',
  DUPLICATE_COPY: 'DUPLICATE_COPY'
} as const

export type MessageVulnerabilityOrigin = (typeof MessageVulnerabilityOrigin)[keyof typeof MessageVulnerabilityOrigin]


export const ContactVulnerabilityFlagStatus = {
  ACTIVE: 'ACTIVE',
  EXPIRED: 'EXPIRED',
  RESOLVED: 'RESOLVED',
  DISMISSED: 'DISMISSED'
} as const

export type ContactVulnerabilityFlagStatus = (typeof ContactVulnerabilityFlagStatus)[keyof typeof ContactVulnerabilityFlagStatus]


export const VulnerabilitySeverity = {
  LOW: 'LOW',
  MEDIUM: 'MEDIUM',
  HIGH: 'HIGH',
  CRITICAL: 'CRITICAL'
} as const

export type VulnerabilitySeverity = (typeof VulnerabilitySeverity)[keyof typeof VulnerabilitySeverity]


export const VersionMatchingDate = {
  DATE_OCCURRED: 'DATE_OCCURRED',
  DATE_IDENTIFIED: 'DATE_IDENTIFIED'
} as const

export type VersionMatchingDate = (typeof VersionMatchingDate)[keyof typeof VersionMatchingDate]


export const McpAccessSetting = {
  ON: 'ON',
  OFF: 'OFF',
  INHERIT: 'INHERIT'
} as const

export type McpAccessSetting = (typeof McpAccessSetting)[keyof typeof McpAccessSetting]


export const NavLogoDisplay = {
  NAME_ONLY: 'NAME_ONLY',
  LOGO_AND_NAME: 'LOGO_AND_NAME',
  LOGO_ONLY: 'LOGO_ONLY'
} as const

export type NavLogoDisplay = (typeof NavLogoDisplay)[keyof typeof NavLogoDisplay]


export const OrgDigestReportStatus = {
  pending: 'pending',
  analysing: 'analysing',
  generated: 'generated',
  sending: 'sending',
  sent: 'sent',
  skipped: 'skipped',
  failed: 'failed',
  email_failed: 'email_failed'
} as const

export type OrgDigestReportStatus = (typeof OrgDigestReportStatus)[keyof typeof OrgDigestReportStatus]


export const OrgDigestType = {
  operational: 'operational',
  boardRiskCompliance: 'boardRiskCompliance'
} as const

export type OrgDigestType = (typeof OrgDigestType)[keyof typeof OrgDigestType]


export const IntegrationProvider = {
  CLEAR21: 'CLEAR21',
  RAVIN_AI: 'RAVIN_AI',
  AUTOGRAB: 'AUTOGRAB'
} as const

export type IntegrationProvider = (typeof IntegrationProvider)[keyof typeof IntegrationProvider]


export const OutboundMessageKind = {
  LODGEMENT_CLAIMANT_CONFIRMATION: 'LODGEMENT_CLAIMANT_CONFIRMATION',
  LODGEMENT_INTERNAL_NOTIFICATION: 'LODGEMENT_INTERNAL_NOTIFICATION',
  LODGEMENT_DRAFT_RESUME: 'LODGEMENT_DRAFT_RESUME',
  LODGEMENT_CLAIM_COMPLETION: 'LODGEMENT_CLAIM_COMPLETION',
  TASK_REMINDER: 'TASK_REMINDER',
  DRIVER_VERIFICATION_CODE: 'DRIVER_VERIFICATION_CODE'
} as const

export type OutboundMessageKind = (typeof OutboundMessageKind)[keyof typeof OutboundMessageKind]


export const OutboundMessageChannel = {
  EMAIL: 'EMAIL',
  SMS: 'SMS'
} as const

export type OutboundMessageChannel = (typeof OutboundMessageChannel)[keyof typeof OutboundMessageChannel]


export const OutboundMessageStatus = {
  QUEUED: 'QUEUED',
  SENDING: 'SENDING',
  SENT: 'SENT',
  DELIVERED: 'DELIVERED',
  BOUNCED: 'BOUNCED',
  DROPPED: 'DROPPED',
  FAILED: 'FAILED',
  SKIPPED: 'SKIPPED'
} as const

export type OutboundMessageStatus = (typeof OutboundMessageStatus)[keyof typeof OutboundMessageStatus]


export const PsdProcessingStatus = {
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED'
} as const

export type PsdProcessingStatus = (typeof PsdProcessingStatus)[keyof typeof PsdProcessingStatus]


export const PatIssuanceMethod = {
  ui: 'ui',
  oauth: 'oauth'
} as const

export type PatIssuanceMethod = (typeof PatIssuanceMethod)[keyof typeof PatIssuanceMethod]


export const PatSurface = {
  mcp: 'mcp',
  trpc: 'trpc',
  mcpAdmin: 'mcpAdmin',
  mcpOps: 'mcpOps'
} as const

export type PatSurface = (typeof PatSurface)[keyof typeof PatSurface]


export const ProductVersionFileType = {
  POLICY_WORDING: 'POLICY_WORDING',
  PDS: 'PDS',
  SUPPLEMENTARY_PDS: 'SUPPLEMENTARY_PDS'
} as const

export type ProductVersionFileType = (typeof ProductVersionFileType)[keyof typeof ProductVersionFileType]


export const ProductVersionContactTypeFieldType = {
  FULL_NAME: 'FULL_NAME',
  PHONE_NUMBER: 'PHONE_NUMBER',
  EMAIL: 'EMAIL',
  ADDRESS: 'ADDRESS',
  COMPANY_NAME: 'COMPANY_NAME',
  DATE_OF_BIRTH: 'DATE_OF_BIRTH',
  RELATIONSHIP_TO_CLAIMANT: 'RELATIONSHIP_TO_CLAIMANT',
  WITNESS_STATEMENT: 'WITNESS_STATEMENT',
  NOTES: 'NOTES'
} as const

export type ProductVersionContactTypeFieldType = (typeof ProductVersionContactTypeFieldType)[keyof typeof ProductVersionContactTypeFieldType]


export const ProductVersionFieldMappingTarget = {
  CLAIM_FIELD: 'CLAIM_FIELD',
  CUSTOM_FIELD: 'CUSTOM_FIELD',
  CONTACT_FIELD: 'CONTACT_FIELD'
} as const

export type ProductVersionFieldMappingTarget = (typeof ProductVersionFieldMappingTarget)[keyof typeof ProductVersionFieldMappingTarget]


export const CoverageBasis = {
  OCCURRENCE: 'OCCURRENCE',
  CLAIMS_MADE: 'CLAIMS_MADE',
  CLAIMS_MADE_AND_NOTIFIED: 'CLAIMS_MADE_AND_NOTIFIED'
} as const

export type CoverageBasis = (typeof CoverageBasis)[keyof typeof CoverageBasis]


export const ProductVersionStatus = {
  DRAFT: 'DRAFT',
  PUBLISHED: 'PUBLISHED'
} as const

export type ProductVersionStatus = (typeof ProductVersionStatus)[keyof typeof ProductVersionStatus]


export const ProductTypeCategory = {
  GENERAL: 'GENERAL',
  FLEET: 'FLEET',
  MOTOR: 'MOTOR'
} as const

export type ProductTypeCategory = (typeof ProductTypeCategory)[keyof typeof ProductTypeCategory]


export const RegisterSystemFieldKey = {
  TITLE: 'TITLE',
  OWNER: 'OWNER',
  NEXT_REVIEW: 'NEXT_REVIEW'
} as const

export type RegisterSystemFieldKey = (typeof RegisterSystemFieldKey)[keyof typeof RegisterSystemFieldKey]


export const RegisterSnapshotScheduleFrequency = {
  ONE_OFF: 'ONE_OFF',
  MONTHLY: 'MONTHLY',
  QUARTERLY: 'QUARTERLY',
  ANNUALLY: 'ANNUALLY'
} as const

export type RegisterSnapshotScheduleFrequency = (typeof RegisterSnapshotScheduleFrequency)[keyof typeof RegisterSnapshotScheduleFrequency]


export const RegisterSnapshotScheduleRunStatus = {
  SUCCEEDED: 'SUCCEEDED',
  FAILED: 'FAILED',
  SKIPPED: 'SKIPPED'
} as const

export type RegisterSnapshotScheduleRunStatus = (typeof RegisterSnapshotScheduleRunStatus)[keyof typeof RegisterSnapshotScheduleRunStatus]


export const SavedViewEntityType = {
  CLAIM: 'CLAIM',
  INCIDENT: 'INCIDENT',
  COMPLAINT: 'COMPLAINT',
  RISK: 'RISK',
  OBLIGATION: 'OBLIGATION',
  USER_ATTESTATION: 'USER_ATTESTATION',
  USER_ATTESTATION_SCHEDULE: 'USER_ATTESTATION_SCHEDULE',
  USER: 'USER',
  DOCUMENT: 'DOCUMENT'
} as const

export type SavedViewEntityType = (typeof SavedViewEntityType)[keyof typeof SavedViewEntityType]


export const SavedViewScope = {
  PERSONAL: 'PERSONAL',
  ORG: 'ORG'
} as const

export type SavedViewScope = (typeof SavedViewScope)[keyof typeof SavedViewScope]


export const ScheduledUserAttestationFrequency = {
  DAILY: 'DAILY',
  WEEKLY: 'WEEKLY',
  FORTNIGHTLY: 'FORTNIGHTLY',
  MONTHLY: 'MONTHLY',
  EVERY_3_MONTHS: 'EVERY_3_MONTHS',
  EVERY_6_MONTHS: 'EVERY_6_MONTHS',
  ANNUALLY: 'ANNUALLY'
} as const

export type ScheduledUserAttestationFrequency = (typeof ScheduledUserAttestationFrequency)[keyof typeof ScheduledUserAttestationFrequency]


export const ScheduledUserAttestationStatus = {
  ACTIVE: 'ACTIVE',
  DISABLED: 'DISABLED',
  COMPLETED: 'COMPLETED'
} as const

export type ScheduledUserAttestationStatus = (typeof ScheduledUserAttestationStatus)[keyof typeof ScheduledUserAttestationStatus]


export const ScheduledUserAttestationRunStatus = {
  SUCCEEDED: 'SUCCEEDED',
  FAILED: 'FAILED',
  SKIPPED: 'SKIPPED'
} as const

export type ScheduledUserAttestationRunStatus = (typeof ScheduledUserAttestationRunStatus)[keyof typeof ScheduledUserAttestationRunStatus]


export const ScheduledUserAttestationRecipientMode = {
  USERS: 'USERS',
  HANDLING_PARTIES: 'HANDLING_PARTIES',
  ALL_ACTIVE: 'ALL_ACTIVE'
} as const

export type ScheduledUserAttestationRecipientMode = (typeof ScheduledUserAttestationRecipientMode)[keyof typeof ScheduledUserAttestationRecipientMode]


export const SupportSessionStatus = {
  pending: 'pending',
  approved: 'approved',
  rejected: 'rejected',
  expired: 'expired',
  revoked: 'revoked'
} as const

export type SupportSessionStatus = (typeof SupportSessionStatus)[keyof typeof SupportSessionStatus]


export const SupportSessionSource = {
  admin_request: 'admin_request',
  onboarding: 'onboarding'
} as const

export type SupportSessionSource = (typeof SupportSessionSource)[keyof typeof SupportSessionSource]


export const SystemAlertType = {
  AI_MODEL_EXPIRY: 'AI_MODEL_EXPIRY',
  INTEGRATION_TEST_FAILURE: 'INTEGRATION_TEST_FAILURE'
} as const

export type SystemAlertType = (typeof SystemAlertType)[keyof typeof SystemAlertType]


export const SystemAlertSeverity = {
  INFO: 'INFO',
  WARNING: 'WARNING',
  CRITICAL: 'CRITICAL'
} as const

export type SystemAlertSeverity = (typeof SystemAlertSeverity)[keyof typeof SystemAlertSeverity]


export const SystemAlertStatus = {
  ACTIVE: 'ACTIVE',
  RESOLVED: 'RESOLVED'
} as const

export type SystemAlertStatus = (typeof SystemAlertStatus)[keyof typeof SystemAlertStatus]


export const TaskResolution = {
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED'
} as const

export type TaskResolution = (typeof TaskResolution)[keyof typeof TaskResolution]


export const TaskReminderOffset = {
  ON_THE_DAY: 'ON_THE_DAY',
  ONE_DAY_BEFORE: 'ONE_DAY_BEFORE',
  TWO_DAYS_BEFORE: 'TWO_DAYS_BEFORE',
  THREE_DAYS_BEFORE: 'THREE_DAYS_BEFORE',
  FIVE_DAYS_BEFORE: 'FIVE_DAYS_BEFORE',
  SEVEN_DAYS_BEFORE: 'SEVEN_DAYS_BEFORE',
  TWO_WEEKS_BEFORE: 'TWO_WEEKS_BEFORE',
  THREE_WEEKS_BEFORE: 'THREE_WEEKS_BEFORE',
  ONE_MONTH_BEFORE: 'ONE_MONTH_BEFORE'
} as const

export type TaskReminderOffset = (typeof TaskReminderOffset)[keyof typeof TaskReminderOffset]


export const TaskReminderOutcome = {
  SENT: 'SENT',
  SKIPPED: 'SKIPPED'
} as const

export type TaskReminderOutcome = (typeof TaskReminderOutcome)[keyof typeof TaskReminderOutcome]


export const UserAttestationStatus = {
  SENT: 'SENT',
  RECEIVED: 'RECEIVED',
  OVERDUE: 'OVERDUE',
  PASSED: 'PASSED',
  FAILED: 'FAILED',
  CANCELLED: 'CANCELLED'
} as const

export type UserAttestationStatus = (typeof UserAttestationStatus)[keyof typeof UserAttestationStatus]


export const UserAttestationEventType = {
  SENT: 'SENT',
  REMINDER_DUE_SOON: 'REMINDER_DUE_SOON',
  REMINDER_DUE_TODAY: 'REMINDER_DUE_TODAY',
  SUBMITTED: 'SUBMITTED',
  REVIEW_PASSED: 'REVIEW_PASSED',
  REVIEW_FAILED: 'REVIEW_FAILED',
  REOPENED: 'REOPENED',
  STATUS_CORRECTED: 'STATUS_CORRECTED',
  COMMENT_ADDED: 'COMMENT_ADDED',
  MARKED_OVERDUE: 'MARKED_OVERDUE',
  CANCELLED: 'CANCELLED',
  REMINDER_MANUAL: 'REMINDER_MANUAL',
  DUE_DATE_CHANGED: 'DUE_DATE_CHANGED'
} as const

export type UserAttestationEventType = (typeof UserAttestationEventType)[keyof typeof UserAttestationEventType]


export const UserInvitationStatus = {
  PENDING: 'PENDING',
  ACCEPTED: 'ACCEPTED',
  SUPERSEDED: 'SUPERSEDED',
  REVOKED: 'REVOKED'
} as const

export type UserInvitationStatus = (typeof UserInvitationStatus)[keyof typeof UserInvitationStatus]


export const VehicleAssessmentEventSource = {
  WEBHOOK: 'WEBHOOK',
  REGISTER_DIFF: 'REGISTER_DIFF'
} as const

export type VehicleAssessmentEventSource = (typeof VehicleAssessmentEventSource)[keyof typeof VehicleAssessmentEventSource]


export const VehicleAssessmentRequestType = {
  DESKTOP_ASSESSMENT: 'DESKTOP_ASSESSMENT',
  QUOTE_REQUEST: 'QUOTE_REQUEST'
} as const

export type VehicleAssessmentRequestType = (typeof VehicleAssessmentRequestType)[keyof typeof VehicleAssessmentRequestType]


export const VehicleAssessmentRequestSource = {
  MANUAL: 'MANUAL',
  AUTO_EXCESS: 'AUTO_EXCESS'
} as const

export type VehicleAssessmentRequestSource = (typeof VehicleAssessmentRequestSource)[keyof typeof VehicleAssessmentRequestSource]


export const VehicleAssessmentStatus = {
  REQUEST_SENT: 'REQUEST_SENT',
  REQUEST_FAILED: 'REQUEST_FAILED',
  CREATED: 'CREATED',
  CLOSED: 'CLOSED'
} as const

export type VehicleAssessmentStatus = (typeof VehicleAssessmentStatus)[keyof typeof VehicleAssessmentStatus]


export const VehicleInspectionStatus = {
  LINK_REQUESTED: 'LINK_REQUESTED',
  REPORT_RECEIVED: 'REPORT_RECEIVED',
  PROCESSING: 'PROCESSING',
  PROCESSED: 'PROCESSED',
  FAILED: 'FAILED'
} as const

export type VehicleInspectionStatus = (typeof VehicleInspectionStatus)[keyof typeof VehicleInspectionStatus]


export const ComplianceOverallResult = {
  COMPLIANT: 'COMPLIANT',
  NON_COMPLIANT: 'NON_COMPLIANT',
  PARTIALLY_COMPLIANT: 'PARTIALLY_COMPLIANT'
} as const

export type ComplianceOverallResult = (typeof ComplianceOverallResult)[keyof typeof ComplianceOverallResult]


export const WhatsNewReleaseStatus = {
  DRAFT: 'DRAFT',
  PUBLISHED: 'PUBLISHED',
  ARCHIVED: 'ARCHIVED'
} as const

export type WhatsNewReleaseStatus = (typeof WhatsNewReleaseStatus)[keyof typeof WhatsNewReleaseStatus]


export const WhatsNewAudience = {
  ALL: 'ALL',
  ROLES: 'ROLES'
} as const

export type WhatsNewAudience = (typeof WhatsNewAudience)[keyof typeof WhatsNewAudience]


export const WorkflowDispatchStatus = {
  PENDING: 'PENDING',
  COMPLETED: 'COMPLETED',
  ABANDONED: 'ABANDONED'
} as const

export type WorkflowDispatchStatus = (typeof WorkflowDispatchStatus)[keyof typeof WorkflowDispatchStatus]


export const MsprProviderType = {
  THIRD_PARTY: 'THIRD_PARTY',
  FOURTH_PARTY: 'FOURTH_PARTY',
  BOTH: 'BOTH'
} as const

export type MsprProviderType = (typeof MsprProviderType)[keyof typeof MsprProviderType]


export const DisplayColor = {
  RED: 'RED',
  ORANGE: 'ORANGE',
  YELLOW: 'YELLOW',
  GREEN: 'GREEN',
  CYAN: 'CYAN',
  BLUE: 'BLUE',
  VIOLET: 'VIOLET',
  PINK: 'PINK',
  GRAY: 'GRAY'
} as const

export type DisplayColor = (typeof DisplayColor)[keyof typeof DisplayColor]


export const ContentFormat = {
  HTML: 'HTML',
  PLAIN_TEXT: 'PLAIN_TEXT',
  JSON: 'JSON'
} as const

export type ContentFormat = (typeof ContentFormat)[keyof typeof ContentFormat]


export const EntityHistoryKind = {
  CREATE: 'CREATE',
  UPDATE: 'UPDATE'
} as const

export type EntityHistoryKind = (typeof EntityHistoryKind)[keyof typeof EntityHistoryKind]


export const NotificationKind = {
  EMAIL: 'EMAIL',
  AI_LODGEMENT_RUN_RECORDED: 'AI_LODGEMENT_RUN_RECORDED',
  AI_LODGEMENT_RUN_LODGED: 'AI_LODGEMENT_RUN_LODGED',
  AI_LODGEMENT_RUN_HELD: 'AI_LODGEMENT_RUN_HELD',
  AI_LODGEMENT_RUN_EXPIRING: 'AI_LODGEMENT_RUN_EXPIRING'
} as const

export type NotificationKind = (typeof NotificationKind)[keyof typeof NotificationKind]


export const ClassificationConfidenceLevel = {
  LOW: 'LOW',
  MEDIUM: 'MEDIUM',
  HIGH: 'HIGH'
} as const

export type ClassificationConfidenceLevel = (typeof ClassificationConfidenceLevel)[keyof typeof ClassificationConfidenceLevel]


export const ScrapedDataStatus = {
  DOWNLOADING: 'DOWNLOADING',
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
  ANALYZING: 'ANALYZING'
} as const

export type ScrapedDataStatus = (typeof ScrapedDataStatus)[keyof typeof ScrapedDataStatus]


export const FaqVisibility = {
  PUBLIC: 'PUBLIC',
  AI_ONLY: 'AI_ONLY'
} as const

export type FaqVisibility = (typeof FaqVisibility)[keyof typeof FaqVisibility]


export const FaqStatus = {
  DRAFT: 'DRAFT',
  PUBLISHED: 'PUBLISHED',
  ARCHIVED: 'ARCHIVED'
} as const

export type FaqStatus = (typeof FaqStatus)[keyof typeof FaqStatus]


export const DocumentCategory = {
  INVOICE: 'INVOICE',
  RECEIPT: 'RECEIPT',
  BANK_STATEMENT: 'BANK_STATEMENT',
  PAYSLIP: 'PAYSLIP',
  TAX_FORM: 'TAX_FORM',
  POLICY_SCHEDULE: 'POLICY_SCHEDULE',
  POLICY_WORDING: 'POLICY_WORDING',
  CERTIFICATE_OF_CURRENCY: 'CERTIFICATE_OF_CURRENCY',
  POLICY_ENDORSEMENT: 'POLICY_ENDORSEMENT',
  POLICY_RENEWAL: 'POLICY_RENEWAL',
  POLICY_QUOTE: 'POLICY_QUOTE',
  POLICY_CANCELLATION: 'POLICY_CANCELLATION',
  FSG: 'FSG',
  PDS: 'PDS',
  CLAIM_FORM: 'CLAIM_FORM',
  LOSS_REPORT: 'LOSS_REPORT',
  ASSESSMENT_REPORT: 'ASSESSMENT_REPORT',
  MEDICAL_REPORT: 'MEDICAL_REPORT',
  ID_DOCUMENT: 'ID_DOCUMENT',
  DRIVERS_LICENCE: 'DRIVERS_LICENCE',
  PASSPORT: 'PASSPORT',
  LETTER: 'LETTER',
  LEGAL_NOTICE: 'LEGAL_NOTICE',
  CONTRACT: 'CONTRACT',
  AGREEMENT: 'AGREEMENT',
  TERMS_AND_CONDITIONS: 'TERMS_AND_CONDITIONS',
  FORM: 'FORM',
  CERTIFICATE: 'CERTIFICATE',
  PHOTO_EVIDENCE: 'PHOTO_EVIDENCE',
  OTHER: 'OTHER'
} as const

export type DocumentCategory = (typeof DocumentCategory)[keyof typeof DocumentCategory]


export const ExtractionStatus = {
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  SKIPPED: 'SKIPPED',
  CANCELLED: 'CANCELLED'
} as const

export type ExtractionStatus = (typeof ExtractionStatus)[keyof typeof ExtractionStatus]


export const ExtractionMethod = {
  LLM_EXTRACTION: 'LLM_EXTRACTION',
  TEXT: 'TEXT',
  TEXT_THEN_LLM: 'TEXT_THEN_LLM',
  MANUAL: 'MANUAL',
  DATALAB: 'DATALAB',
  MISTRAL_OCR: 'MISTRAL_OCR',
  LLM_VISION: 'LLM_VISION'
} as const

export type ExtractionMethod = (typeof ExtractionMethod)[keyof typeof ExtractionMethod]


export const CategorySource = {
  AI_CLASSIFIED: 'AI_CLASSIFIED',
  FILENAME_PATTERN: 'FILENAME_PATTERN',
  MIME_TYPE: 'MIME_TYPE',
  USER_SPECIFIED: 'USER_SPECIFIED',
  UPLOAD_CONTEXT: 'UPLOAD_CONTEXT'
} as const

export type CategorySource = (typeof CategorySource)[keyof typeof CategorySource]


export const EmbeddingStatus = {
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  SKIPPED: 'SKIPPED'
} as const

export type EmbeddingStatus = (typeof EmbeddingStatus)[keyof typeof EmbeddingStatus]


export const WeaviateSyncStatus = {
  PENDING: 'PENDING',
  SYNCED: 'SYNCED',
  FAILED: 'FAILED'
} as const

export type WeaviateSyncStatus = (typeof WeaviateSyncStatus)[keyof typeof WeaviateSyncStatus]


export const WeaviateChunkStatus = {
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  SYNCED: 'SYNCED',
  FAILED: 'FAILED'
} as const

export type WeaviateChunkStatus = (typeof WeaviateChunkStatus)[keyof typeof WeaviateChunkStatus]
